import { Constants } from '@pwc/pwc-deals-web-common';
import { get, cloneDeep } from 'lodash';
import { getExcelLibraryItemsByGroup } from '../../../contentLibrary/libraryItemService';

class CellRangeLibraryItem {
  constructor(libraryItem, formatType = 'HTML') {
    this.data = JSON.parse(libraryItem.data);
    this.type = libraryItem.type;
    this.libraryItemType = Constants.LIBRARY_ITEM_TYPES.EXCEL_CELL_RANGE.value;
    this.formatType = formatType;
    this.service = getExcelLibraryItemsByGroup;
    this.libraryItem = libraryItem;

    this.error = null;
    this.content = undefined;
  }

  get sharePointUrl() {
    return this.data.sharePointUrl;
  }

  extractSourceName() {
    const source = {
      source: `${this.data.name || this.data.Name}`,
    };
    return source;
  }

  getRequestPayload({ formatTypes = ['HTML', 'SVG'] } = {}) {
    return {
      ...cloneDeep(this.data),
      excelLibraryItems: formatTypes.reduce((acc, format) => {
        switch (format) {
          case 'HTML':
          case 'SVG':
            acc.push({
              id: this.libraryItem.id,
              name: this.libraryItem.name,
              type: this.libraryItem.type,
              data: {
                formatType: format,
                cellRange: get(this.data, 'Name'),
                workSheetName: get(this.data, 'WorksheetName'),
                uniqueId: get(this.data, 'UniqueId'),
              },
            });
            break;

          default:
            throw new Error(`Invalid format: ${format}`);
        }

        return acc;
      }, []),
    };
  }
}

export default CellRangeLibraryItem;
